function roundRect(ctx, x, y, w, h, r) {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.arcTo(x + w, y, x + w, y + h, r);
  ctx.arcTo(x + w, y + h, x, y + h, r);
  ctx.arcTo(x, y + h, x, y, r);
  ctx.arcTo(x, y, x + w, y, r);
  ctx.closePath();
}

const MONTHS_CS = ["Leden", "Únor", "Březen", "Duben", "Květen", "Červen", "Červenec", "Srpen", "Září", "Říjen", "Listopad", "Prosinec"];
const MONTHS_EN = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export function computeMonthlyStats(items) {
  const now = new Date();
  const ym = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
  const monthly = items.filter((t) => (t.created_at || "").startsWith(ym));
  const closed = monthly.filter((t) => ["win", "loss"].includes(t.result));
  const wins = closed.filter((t) => t.result === "win").length;
  const winRate = closed.length ? Math.round((wins / closed.length) * 100) : 0;
  const pnl = monthly.reduce((s, t) => s + (t.pnl || 0), 0);
  const grossWin = monthly.reduce((s, t) => s + Math.max(0, t.pnl || 0), 0);
  const grossLoss = monthly.reduce((s, t) => s + Math.max(0, -(t.pnl || 0)), 0);
  const pf = grossLoss > 0 ? (grossWin / grossLoss).toFixed(2) : grossWin > 0 ? "∞" : "0";
  const best = monthly.reduce((m, t) => Math.max(m, t.pnl || 0), 0);
  return { trades: monthly.length, closed: closed.length, winRate, pnl, pf, best, month: now.getMonth(), year: now.getFullYear() };
}

function statBox(ctx, x, y, w, label, value, color) {
  ctx.fillStyle = "rgba(24,24,27,0.8)";
  roundRect(ctx, x, y, w, 130, 16);
  ctx.fill();
  ctx.strokeStyle = "rgba(39,39,42,1)";
  ctx.lineWidth = 1.5;
  roundRect(ctx, x, y, w, 130, 16);
  ctx.stroke();
  ctx.textAlign = "center";
  ctx.font = "500 20px 'JetBrains Mono', monospace";
  ctx.fillStyle = "#71717a";
  ctx.fillText(label, x + w / 2, y + 42);
  ctx.font = "700 42px 'JetBrains Mono', monospace";
  ctx.fillStyle = color || "#fafafa";
  ctx.fillText(value, x + w / 2, y + 96);
}

export async function sharePerformance(items, lang = "cs", folderName = null) {
  const s = computeMonthlyStats(items);
  const cs = lang === "cs";
  const monthLabel = `${(cs ? MONTHS_CS : MONTHS_EN)[s.month]} ${s.year}`;
  const W = 1080, H = 1080;
  const canvas = document.createElement("canvas");
  canvas.width = W;
  canvas.height = H;
  const ctx = canvas.getContext("2d");

  ctx.fillStyle = "#09090b";
  ctx.fillRect(0, 0, W, H);
  ctx.strokeStyle = "rgba(24,24,27,0.9)";
  ctx.lineWidth = 1;
  for (let x = 0; x <= W; x += 72) { ctx.beginPath(); ctx.moveTo(x, 0); ctx.lineTo(x, H); ctx.stroke(); }
  for (let y = 0; y <= H; y += 72) { ctx.beginPath(); ctx.moveTo(0, y); ctx.lineTo(W, y); ctx.stroke(); }
  ctx.fillStyle = "#d4a017";
  ctx.fillRect(0, 0, W, 10);

  // Header — logo image
  await new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      ctx.save();
      roundRect(ctx, 70, 60, 64, 64, 12);
      ctx.clip();
      ctx.drawImage(img, 70, 60, 64, 64);
      ctx.restore();
      resolve();
    };
    img.onerror = () => {
      ctx.fillStyle = "#d4a017";
      roundRect(ctx, 70, 60, 64, 64, 12);
      ctx.fill();
      resolve();
    };
    img.src = "/icons/icon-192.png";
  });
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.textAlign = "left";
  ctx.font = "700 44px 'Outfit', Arial, sans-serif";
  ctx.fillStyle = "#fafafa";
  ctx.fillText("TradeMind", 155, 92);
  const tw = ctx.measureText("TradeMind ").width;
  ctx.fillStyle = "#e3b341";
  ctx.fillText("AI", 155 + tw, 92);
  ctx.font = "500 22px 'JetBrains Mono', monospace";
  ctx.fillStyle = "#71717a";
  ctx.textAlign = "right";
  ctx.fillText(cs ? "MĚSÍČNÍ VÝKON" : "MONTHLY PERFORMANCE", W - 70, 92);

  // Month + folder
  ctx.textAlign = "left";
  ctx.font = "700 64px 'Outfit', Arial, sans-serif";
  ctx.fillStyle = "#fafafa";
  ctx.fillText(monthLabel, 70, 220);
  if (folderName) {
    ctx.font = "500 26px 'JetBrains Mono', monospace";
    ctx.fillStyle = "#e3b341";
    ctx.fillText(`📁 ${folderName}`, 70, 268);
  }

  // Big P/L
  const pnlColor = s.pnl >= 0 ? "#22c55e" : "#ef4444";
  ctx.fillStyle = s.pnl >= 0 ? "rgba(34,197,94,0.08)" : "rgba(239,68,68,0.08)";
  roundRect(ctx, 70, 310, W - 140, 220, 20);
  ctx.fill();
  ctx.strokeStyle = s.pnl >= 0 ? "rgba(34,197,94,0.35)" : "rgba(239,68,68,0.35)";
  ctx.lineWidth = 2;
  roundRect(ctx, 70, 310, W - 140, 220, 20);
  ctx.stroke();
  ctx.textAlign = "center";
  ctx.font = "500 24px 'JetBrains Mono', monospace";
  ctx.fillStyle = "#71717a";
  ctx.fillText(cs ? "ZISK / ZTRÁTA" : "PROFIT / LOSS", W / 2, 365);
  ctx.font = "700 96px 'JetBrains Mono', monospace";
  ctx.fillStyle = pnlColor;
  ctx.fillText(`${s.pnl >= 0 ? "+" : "−"}$${Math.abs(s.pnl).toLocaleString("en-US", { maximumFractionDigits: 0 })}`, W / 2, 470);

  // Stat boxes
  const gap = 24;
  const bw = (W - 140 - gap * 2) / 3;
  statBox(ctx, 70, 580, bw, cs ? "OBCHODY" : "TRADES", String(s.trades));
  statBox(ctx, 70 + bw + gap, 580, bw, "WIN RATE", `${s.winRate}%`, s.winRate >= 50 ? "#22c55e" : "#f59e0b");
  statBox(ctx, 70 + (bw + gap) * 2, 580, bw, "PROFIT FACTOR", String(s.pf));
  statBox(ctx, 70, 740, bw, cs ? "UZAVŘENO" : "CLOSED", String(s.closed));
  statBox(ctx, 70 + bw + gap, 740, bw, cs ? "NEJLEPŠÍ OBCHOD" : "BEST TRADE", `+$${s.best.toLocaleString("en-US", { maximumFractionDigits: 0 })}`, "#22c55e");
  statBox(ctx, 70 + (bw + gap) * 2, 740, bw, cs ? "MĚSÍC" : "MONTH", monthLabel.split(" ")[0].substring(0, 8));

  // Footer
  ctx.strokeStyle = "rgba(39,39,42,1)";
  ctx.beginPath();
  ctx.moveTo(70, 950);
  ctx.lineTo(W - 70, 950);
  ctx.stroke();
  ctx.textAlign = "left";
  ctx.font = "700 30px 'Outfit', Arial, sans-serif";
  ctx.fillStyle = "#e3b341";
  ctx.fillText("trademind.cz", 70, 1005);
  ctx.textAlign = "right";
  ctx.font = "600 24px 'Outfit', Arial, sans-serif";
  ctx.fillStyle = "#fafafa";
  ctx.fillText(cs ? "Přidej se zdarma → trademind.cz" : "Join free → trademind.cz", W - 70, 1005);
  ctx.textAlign = "left";
  ctx.font = "400 19px Arial, sans-serif";
  ctx.fillStyle = "#52525b";
  ctx.fillText(cs ? "Deník vedený s AI asistentem TradeMind. Nejedná se o investiční doporučení." : "Journal powered by TradeMind AI. Not financial advice.", 70, 1040);

  const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/png"));
  const file = new File([blob], `trademind-vykon-${s.year}-${s.month + 1}.png`, { type: "image/png" });
  const text = cs
    ? `Můj ${monthLabel} v číslech: ${s.trades} obchodů, win rate ${s.winRate}% — TradeMind AI\n\nPřidej se zdarma: https://trademind.cz`
    : `My ${monthLabel} in numbers: ${s.trades} trades, ${s.winRate}% win rate — TradeMind AI\n\nJoin free: https://trademind.cz`;
  if (navigator.canShare && navigator.canShare({ files: [file] })) {
    await navigator.share({ files: [file], title: "TradeMind AI", text, url: "https://trademind.cz" });
    return "shared";
  }
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = file.name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
  return "downloaded";
}
